__turbopack_context__.v({
  "backButton": "HelpDrawer-module-scss-module__bnG-tW__backButton",
  "disabled": "HelpDrawer-module-scss-module__bnG-tW__disabled",
  "dragBar": "HelpDrawer-module-scss-module__bnG-tW__dragBar",
  "dragHandle": "HelpDrawer-module-scss-module__bnG-tW__dragHandle",
  "drawer": "HelpDrawer-module-scss-module__bnG-tW__drawer",
  "fadeIn": "HelpDrawer-module-scss-module__bnG-tW__fadeIn",
  "feedbackBody": "HelpDrawer-module-scss-module__bnG-tW__feedbackBody",
  "headerDivider": "HelpDrawer-module-scss-module__bnG-tW__headerDivider",
  "item": "HelpDrawer-module-scss-module__bnG-tW__item",
  "itemChevron": "HelpDrawer-module-scss-module__bnG-tW__itemChevron",
  "itemIcon": "HelpDrawer-module-scss-module__bnG-tW__itemIcon",
  "itemLabel": "HelpDrawer-module-scss-module__bnG-tW__itemLabel",
  "overlay": "HelpDrawer-module-scss-module__bnG-tW__overlay",
  "section": "HelpDrawer-module-scss-module__bnG-tW__section",
  "sectionWithBorder": "HelpDrawer-module-scss-module__bnG-tW__sectionWithBorder",
  "slideUp": "HelpDrawer-module-scss-module__bnG-tW__slideUp",
  "srOnly": "HelpDrawer-module-scss-module__bnG-tW__srOnly",
  "view": "HelpDrawer-module-scss-module__bnG-tW__view",
  "viewHeader": "HelpDrawer-module-scss-module__bnG-tW__viewHeader",
  "viewTitle": "HelpDrawer-module-scss-module__bnG-tW__viewTitle",
  "viewsContainer": "HelpDrawer-module-scss-module__bnG-tW__viewsContainer",
  "viewsFeedback": "HelpDrawer-module-scss-module__bnG-tW__viewsFeedback",
  "viewsMenu": "HelpDrawer-module-scss-module__bnG-tW__viewsMenu",
});
